export default __webpack_public_path__ + "static/media/img2.a6321edf.jpg";